(function ($) {
	$(function () {
		$('.newsListOverload').overLoading({
			$box: $('.newsList'),
			items: '.newsBox'
		});
	});
})(jQuery);